var menubar = {
	currentTab:null,
	
	setActive: function(tab) {
		menubar.closeCurrent();
		menubar.currentTab = tab;
		$("#menubar a").removeClass("active");
		$(tab.menuButton).addClass("active");
	},
	
	closeCurrent: function() {
		if (menubar.currentTab != null) {
			menubar.currentTab.close();
			$("#menubar a").removeClass("active");
			$("#menubar_menu").addClass("active");
						
			menubar.currentTab = null;
		} else {
			player.list.openMenu(null);
		}
	}
		
}